import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from '../common/cmpt/modal/Modal';
import Callback from '../app/Callback';

const CallbackForm = (triggers, title, topic, prod) => {
  const onClick = () => {
    const node = document.createElement('div');
    const root = ReactDOM.createRoot(node);
    const destroy = () => {
      root.unmount();
    };

    root.render(
      <React.StrictMode>
        <Modal>
          <Callback destroy={destroy} title={title} topic={topic} prod={prod} isOpen={triggers} />
        </Modal>
      </React.StrictMode>,
    );
  };


  // i added comment for docs !!!!
  // Ensure triggers is an array
  const triggerIds = Array.isArray(triggers) ? triggers : [triggers];

  // Add click event listeners only to elements that exist
  triggerIds.forEach((id) => {
    const trigger = document.getElementById(id);
    if (trigger) {
      trigger.addEventListener('click', onClick);
    } else {
      console.warn(`Element with id "${id}" not found`);
    }
  });

  // Return cleanup function to remove event listeners
  return () => {
    triggerIds.forEach((id) => {
      const trigger = document.getElementById(id);
      if (trigger) {
        trigger.removeEventListener('click', onClick);
      }
    });
  };
};

export default CallbackForm;